import React from 'react';
import './Gallery.css';

const Gallery = ({ currentLanguage }) => {
  const getTranslation = (key) => {
    const translations = {
      en: {
        title: 'Sacred Gallery',
        subtitle: 'Glimpses of our spiritual journey and divine moments'
      },
      hi: {
        title: 'पवित्र गैलरी',
        subtitle: 'हमारी आध्यात्मिक यात्रा और दिव्य क्षणों की झलकियां'
      },
      gu: {
        title: 'પવિત્ર ગેલેરી',
        subtitle: 'અમારી આધ્યાત્મિક યાત્રા અને દિવ્ય ક્ષણોની ઝલકો'
      }
    };
    return translations[currentLanguage]?.[key] || translations.en[key];
  };

  const galleryImages = [
    { src: '/images/gallery/g1.jpeg', title: 'Jagatpur Office' },
    { src: '/images/gallery/g2.jpeg', title: 'Pooja Vidhi' },
    { src: '/images/gallery/g3.jpeg', title: 'Industrial Visit' },
    { src: '/images/gallery/g4.jpeg', title: 'Team Meeting' },
    { src: '/images/gallery/g5.jpeg', title: 'Kudasan Office' }
  ];

  return (
    <section id="gallery" className="gallery">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{getTranslation('title')}</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">{getTranslation('subtitle')}</p>
        </div>
        <div className="gallery-grid">
          {galleryImages.map((item, index) => (
            <div key={index} className="gallery-card">
              <div className="gallery-image">
                <img src={item.src} alt={item.title} />
              </div>
              <div className="gallery-caption">
                <h3>{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;